import React from 'react';
import PropTypes from 'prop-types';
import Link from 'components/Link';

const Title = ({ title, titleUrl, isRailAdjacent }) => {
  const className = isRailAdjacent ? 'cover-spread__headline cover-spread__rail' : 'cover-spread__headline';
  return (
    <h2 className={className} data-test="cover-spread__headline">
      {titleUrl ? (
        <Link href={titleUrl}>
          {title}
        </Link>
      ) : title}
    </h2>
  );
};

Title.propTypes = {
  title: PropTypes.string.isRequired,
  titleUrl: PropTypes.string,
  isRailAdjacent: PropTypes.bool,
};

Title.defaultProps = {
  titleUrl: null,
  isRailAdjacent: false,
};

export default Title;
